<template>
  <svg aria-hidden="true" viewBox="0 0 800 800" ...attributes>
    <path
      fill="#1B2D3C"
      d="M768.5576,244.2957A400.4147,400.4147,0,0,0,244.2959,31.4424a20,20,0,0,0,15.582,36.84A360.0984,360.0984,0,0,1,540.1221,731.7175a359.6208,359.6208,0,0,1-369.5073-54.2344,259.8827,259.8827,0,0,1,413.2329-61.3311,20,20,0,1,0,28.2852-28.2842A299.0888,299.0888,0,0,0,484.07,511.9524a140,140,0,1,0-168.1405,0A300.7,300.7,0,0,0,140.4635,649.4609,360.3847,360.3847,0,0,1,68.2822,259.8782a20,20,0,1,0-36.84-15.5825A400.0983,400.0983,0,0,0,768.5576,555.7043a401.2493,401.2493,0,0,0,0-311.4087ZM300,400A100,100,0,1,1,400,500,100.1133,100.1133,0,0,1,300,400Z"
    ></path>
    <path
      fill="#63CC98"
      d="M400,100a20,20,0,0,0,0,40c143.594,0,260,116.406,260,260a20,20,0,0,0,40,0C700,234.3146,565.6855,100,400,100Z"
    ></path>
  </svg>
</template>
